import axios from "axios";
import AuthService from "../login/auth.service";
import { pronetPagos,cuentas,comprobantes } from "../../components/generico/utils/UrlAPI";

class PagoServicioService {
  constructor(props) {
    this.reemplazarPunto = this.reemplazarPunto.bind(this);
    this.reemplazarBarra = this.reemplazarBarra.bind(this);
  }
  async getCuentasSocio() {
    var data = JSON.stringify({
        canal: "WEB",
        estado: null, 
        modalidad: null,
        moneda: "GS", 
        tipo: "D", 
        tipoCuenta: null
    });

    var config = {
      method: "post",
      url: cuentas+"socio-cuenta/transferencias",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }

  async getServiciosDisponibles() {

    var config = {
      method: "get",
      url: pronetPagos + "getServiciosActivos/" + AuthService.getSocio().numeroSocio,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      timeout: 100000,
    };

    return await axios(config);
  }

  async getCamposFormulario(dato) {
    var data = JSON.stringify({
      cuenta: "0",
      codServicio: dato,
      tipoTrx: "PARAMETROS",
    });

    var config = {
      method: "post",
      url: pronetPagos + "procesarFormularioParam",
      headers: {
        "Content-Type": "application/json",
         Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      timeout: 100000,
      data: data,
    };

    return await axios(config);
  }

  async getDatosConsultaPronet(codigo, dato) {
    var resultado = []

    var jsonData = JSON.parse(JSON.stringify(dato));

    for (var i = 0; i < jsonData.length; i++) {
      var datos = JSON.parse(JSON.stringify(jsonData[i]));
      resultado.push({
        name:
          datos.name,
        value: datos.value

      })
    }

    var data = JSON.stringify({
      codServicio: codigo,
      tipoTrx: "CONSULTA",
      cuenta: "0",
      campo: JSON.parse(JSON.stringify(resultado)),
    });

    var config = {
      method: "post",
      url: pronetPagos + "procesarFormularioConsulta",
      headers: {
        "Content-Type": "application/json",
         Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      timeout: 100000,
      data: data,
    };
    return await axios(config);
  }

  reemplazarPunto(valor) {

    var resultado = valor.replace(".", "");
    var original = resultado;
    var reemplazo = true;
    while (reemplazo) {
      resultado = resultado.replace(".", "");
      if (resultado === original)
        reemplazo = false
      else
        original = resultado

    }
    return resultado;
  };

  reemplazarBarra(valor) {

    var resultado = valor.replace("/", "");
    var original = resultado;

    var reemplazo = true;
    while (reemplazo) {
      resultado = resultado.replace("/", "");
      if (resultado === original)
        reemplazo = false
      else
        original = resultado

    }
    var fecha = original.substring(0, original.length - 4)
    fecha = fecha + original.substring(original.length - 2, original.length) + "000000"

    return fecha;
  };

  async consultarPagoDuplicado(codigoServicio, cuenta, monto, nroBoleta) {
    var data = JSON.stringify({
      codigoServicio: codigoServicio,
      cuentaAhorro: cuenta,
      monto: monto,
      nroBoleta: nroBoleta
    });

    var config = {
      method: "post",
      url: pronetPagos + "consultaPagoDuplicado",
      headers: {
        "Content-Type": "application/json",
         Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      timeout: 100000,
      data: data,
    };

    return await axios(config);
  }


  async pagarPronet(codigo, dato, cuenta, monto, tipo) {

    for (var i = 0; i < dato.length; i++) {
      var valor = JSON.parse(JSON.stringify(dato[i]));


      if (valor.concepto === "monto") {
        var montoTotal = this.reemplazarPunto(dato.valor);
        valor.value = montoTotal
        dato[i] = valor
      }
      if (valor.value.toUpperCase().includes("/")) {
        var fecha = this.reemplazarBarra(valor.value);
        valor.value = fecha
        dato[i] = valor
      }


    }

    var data = JSON.stringify({
      codServicio: codigo,
      tipoTrx: tipo,
      campo: JSON.parse(JSON.stringify(dato)),
      cuenta: cuenta,
      montoTotal: monto,
      canal:"WEB"
    });

    var config = {
      method: "post",
      url: pronetPagos + "procesarFormularioPago",
      headers: {
        "Content-Type": "application/json",
         Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      timeout: 100000,
      data: data,
    };
    return await axios(config);
  }

  async descagarComprobante(titulo, nroOperacion, nroSocioTitular, cuenta, ticket) {
    var _url = comprobantes + "comprobantes/v2/pagos-servicios";
    //var _url = "http://localhost:8080/comprobantes/pagos-servicios";
    var data = JSON.stringify({
      titulo: titulo,
      nroOperacion: nroOperacion,
      nroSocioTitular: nroSocioTitular,
      cuentaDebito: cuenta,
      ticket: ticket
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  
  }

}



export default new PagoServicioService();
